<template>
    <div>
        <h5 class="text-uppercase font-weight-bold ">
            {{ organization ? organization.name : "Your" }} team list
        </h5>
        <div class="position-relative">
            <div
                v-if="
                    isOrganizationSuperUser &&
                        subscription &&
                        subscription.is_subscribed &&
                        ['professional_silver'].includes(organization.type)
                "
                class="list"
            >
                <div class="email bg-white list-item p-2">
                    <div class="row">
                        <div class="col-12" @click="showAddTeamModal()">
                            <p class="mb-0 font-weight-bold text-primary cursor-pointer">
                                <i class="fa fa-plus-circle mr-2"></i>Click here to invite a new
                                team member.
                            </p>
                        </div>
                    </div>
                </div>
            </div>

            <div class="email bg-white list-item p-2">
                <div class="row">
                    <div class="col d-flex">
                        <input
                            id="filter-string"
                            type="text"
                            class="form-control-sm form-control"
                            v-model="filterString"
                            placeholder="Filter by first or last name"
                            autocomplete="off"
                        />
                        <button class="btn btn-link btn-sm text-primary" @click="filterString = ''">
                            Clear
                        </button>
                    </div>
                </div>
            </div>

            <div
                v-if="isOrganizationSuperUser && subscription && !subscription.is_subscribed"
                class="bg-white border-light"
            >
                <p class="text-center pt-5">Upgrade to add team members to your company account.</p>
                <div class="d-flex w-100 justify-content-center align-items-center py-5">
                    <a
                        id="go-account-settings"
                        class="btn btn-sm btn-primary font-weight-bold text-uppercase text-white"
                        href="/account-settings#subscribe"
                        >Upgrade to add team members</a
                    >
                </div>
            </div>

            <div
                v-if="organizationUsersWithoutMe && !organizationUsersWithoutMe.length"
                class="d-flex bg-white list-item p-2"
            >
                <div class="ml-3 d-block details">
                    <p class="p-0 m-0"><em>No other users in the organization.</em></p>
                </div>
            </div>

            <!--CURRENT TEAM USERS-->
            <div
                class="d-flex bg-white list-item p-2 w-100"
                v-if="organizationUsersWithoutMe && organizationUsersWithoutMe.length"
                v-for="(u, i) in organizationUsersWithoutMe"
                :key="`ct${i}`"
            >
                <div>
                    <img class="client-image" :src="u.profile_photo_url" />
                </div>
                <div class="ml-3 d-block details">
                    <h4 class="p-0 m-0">
                        <em>{{ u.name }}</em>
                    </h4>
                    <p class="p-0 m-0 text-uppercase">{{ u.title }}</p>
                    <p class="p-0 m-0">
                        <em>Last Updated: {{ moment(u.updated_at).format("MM/DD/YYYY") }}</em>
                    </p>
                    <p class="p-0 m-0">
                        <b>{{ helpers.formatPhone(u.primary_phone) }}</b>
                    </p>
                    <p class="p-0 m-0 link ellipsis">{{ u.email }}</p>
                </div>
                <div class="ml-auto d-flex justify-content-end align-items-center">
                    <div class="dropdown text-right">
                        <button
                            class="btn btn-sm btn-link text-black"
                            type="button"
                            data-toggle="dropdown"
                            aria-haspopup="true"
                            aria-expanded="false"
                        >
                            <i class="fa fa-ellipsis-v"></i>
                        </button>
                        <div
                            class="dropdown-menu dropdown-menu-right"
                            aria-labelledby="delete-recurring"
                        >
                            <a
                                class="cursor-pointer dropdown-item small actions"
                                :class="canAddClient ? '' : 'text-light cursor-not-allowed'"
                                @click.stop="canAddClient ? showAssignResource(u) : null"
                                >{{ u.first_name }} Client Connections</a
                            >
                            <a
                                class="cursor-pointer dropdown-item small actions text-danger"
                                :class="
                                    canEditStaff ? 'text-danger' : 'text-light cursor-not-allowed'
                                "
                                @click.stop="canEditStaff ? showRemoveTeamModal(u) : null"
                                >Remove {{ u.first_name }} From Team</a
                            >
                        </div>
                    </div>
                </div>
            </div>

            <!--PENDING USERS-->
            <div
                v-if="isOrganizationSuperUser || user.is_super_user"
                class="d-flex list-item p-2"
                style="background-color: #C6E9FF;"
                v-for="i in organizationInvites.filter(invite =>
                    invite.email.toLowerCase().includes(this.filterString.toLowerCase().trim())
                )"
                :key="i.email"
            >
                <div>
                    <img class="client-image" src="/images/default_user.jpeg" />
                </div>
                <div
                    class="ml-3 d-flex flex-column justify-content-center align-items-start details"
                >
                    <h5 class="p-0 m-0">
                        <em>{{ i.email }}</em>
                    </h5>
                    <small
                        ><em class="text-muted"
                            >Invite sent on {{ moment(i.created_at).format("MM/DD/YYYY") }}</em
                        ></small
                    >
                </div>
                <div class="ml-auto mr-2 d-flex flex-column justify-content-center">
                    <div class="flex justify-content-center">
                        <i
                            class="fa fa-refresh fa-lg mx-1"
                            @click="showResendInviteModal(i)"
                            style="cursor: pointer;"
                        ></i>
                        <i
                            class="fa fa-times fa-lg mx-1"
                            @click="showCancelInviteModal(i)"
                            style="cursor: pointer;"
                        ></i>
                    </div>
                </div>
            </div>

            <modal-component
                :id="'team-list-widget-modal'"
                :visible="modal.visible"
                :title="modal.title"
                :size="modal.size"
                @close="resetModal()"
            >
                <!--ADD USER TO ORGANIZATION OR SEND INVITE-->
                <div v-show="modal.type === 0">
                    <div class="w-100 position-relative">
                        <input
                            type="text"
                            id="emailaddress"
                            class="form-control form-control-sm"
                            v-model="inviteEmail"
                            placeholder="Enter E-mail Address"
                        />
                    </div>
                    <p>
                        &nbsp;<em v-if="invalidEmail" class="text-primary"
                            >This e-mail address has already received an invite.</em
                        >
                    </p>
                    <transition name="simple-fade" mode="out-in">
                        <a
                            v-if="
                                !filteredOrganizationUsers.length &&
                                    inviteEmail &&
                                    inviteEmail.length
                            "
                            class="btn btn-primary font-weight-bold text-uppercase text-white my-3"
                            @click="addTeamInvite()"
                            v-html="
                                loading
                                    ? `<i class='fa fa-spin fa-circle-o-notch mr-2'></i> Saving...`
                                    : 'Invite to Team'
                            "
                        ></a>
                        <a
                            v-else=""
                            class="btn btn-light font-weight-bold text-uppercase text-white my-3"
                            >Invite to team</a
                        >
                    </transition>
                    <p>
                        Adding a user to the <b>{{ organization.name }}</b> account will increase
                        the subscription from <b>{{ subscription.quantity }}</b> seats to
                        <b>{{ subscription.quantity + 1 }}</b> seats.
                    </p>
                    <invoice-preview
                        :organization="organization"
                        :subscription="subscription"
                        ref="previewAdd"
                    ></invoice-preview>
                </div>

                <!--CANCEL AN INVITATION-->
                <div v-if="modal.type === 1">
                    <p class="text-center">
                        Are you sure you want to cancel the invitation sent to
                        {{ actionInvite.email }}?
                    </p>
                    <div class="d-flex w-100 justify-content-between align-items-center py-3">
                        <small
                            ><a
                                class="link-primary text-primary font-weight-bold text-uppercase"
                                @click="resetModal()"
                                >No, keep invitation</a
                            ></small
                        >
                        <a
                            class="btn btn-sm btn-primary font-weight-bold text-uppercase text-white"
                            @click="removeTeamInvite(actionInvite.id)"
                            v-html="
                                loading
                                    ? `<i class='fa fa-spin fa-circle-o-notch mr-2'></i> Saving...`
                                    : 'Yes, cancel invitation'
                            "
                        ></a>
                    </div>
                </div>

                <!--RESEND INVITE-->
                <div v-if="modal.type === 2">
                    <p class="text-center">
                        Are you sure you want to resend the invitation sent to
                        {{ actionInvite.email }}?
                    </p>
                    <div class="d-flex w-100 justify-content-between align-items-center py-3">
                        <small
                            ><a
                                class="link-primary text-primary font-weight-bold text-uppercase"
                                @click="resetModal()"
                                >No, don't resend</a
                            ></small
                        >
                        <a
                            class="btn btn-sm btn-primary font-weight-bold text-uppercase text-white"
                            @click="resendTeamInvite(actionInvite.id)"
                            v-html="
                                loading
                                    ? `<i class='fa fa-spin fa-circle-o-notch mr-2'></i> Saving...`
                                    : 'Yes, resend invite'
                            "
                        ></a>
                    </div>
                </div>
            </modal-component>

            <!--REMOVE USER FROM ORGANIZATION -->
            <delete-confirmation
                :id="'team-list-widget-delete'"
                :visible="deleteConfirmationVisible"
                :button-text="'Yes, remove user'"
                @confirm="removeUser(deletePayload.id)"
                @close="resetDelete()"
            >
                <template slot="title">
                    Remove {{ helpers._get(deletePayload, "name", "user") }}?
                </template>
                <template slot="description">
                    <p>
                        <b>{{ organization.name }}</b
                        >'s subscription will decrease from <b>{{ subscription.quantity }}</b> to
                        <b>{{ subscription.quantity - 1 }}</b> seats.
                    </p>
                    <invoice-preview
                        :organization="organization"
                        :subscription="subscription"
                        ref="previewRemove"
                    ></invoice-preview>
                </template>
            </delete-confirmation>

            <assign-resource
                :key="'patients'"
                :user="user"
                :organization="organization"
                :resource="'patients'"
                :selectedAssignee="selectedAssignee"
                :visible="isAssignResourceVisible"
                @handle-close="hideAssignResource"
                @update-resource="showAssignResource(selectedAssignee)"
            ></assign-resource>
        </div>
    </div>
</template>

<script>
import InvoicePreview from "../widgets/UpcomingInvoicePreview";
import ModalComponent from "../ui/ModalComponent";
import AssignResource from "../widgets/AssignResource";
import { permissions } from "../../plugins/permissions";
import { helpers } from "../../plugins/helpers";
import { deleteConfirmation } from "../../plugins/deleteConfirmation";

export default {
    name: "TeamListWidget",
    props: ["organization", "user", "subscription", "deleteConfirmation"],
    components: {
        InvoicePreview,
        ModalComponent,
        AssignResource,
    },
    mixins: [permissions, deleteConfirmation],
    data() {
        return {
            helpers,
            currentTeamUsers: [],
            organizationUsers: [],
            organizationInvites: [],
            selectedUser: null,
            inviteEmail: null,
            actionInvite: null,
            loading: false,
            invalidEmail: false,

            modal: {},
            modals: [
                {
                    visible: false,
                    size: null,
                    title: "Add Team",
                    type: 0,
                },
                {
                    visible: false,
                    size: "sm",
                    title: "Cancel invite",
                    type: 1,
                },
                {
                    visible: false,
                    size: "sm",
                    title: "Resend invite",
                    type: 2,
                },
            ],
            selectedAssignee: null,
            isAssignResourceVisible: false,
            filterString: "",
        };
    },
    created() {
        this.$bus.$on("update-resource", () => this.fetchOrganizationUsers());
    },
    watch: {
        organization: {
            immediate: true,
            handler: function() {
                if (this.organization) {
                    this.fetchOrganizationUsers();
                    this.fetchOrganizationInvites();
                }
            },
        },
        organizationUsers: {
            immediate: false,
            handler: function() {
                if (this.selectedAssignee) {
                    const patients = this.organizationUsers.find(
                        c => c.id === this.selectedAssignee.id
                    ).patients;
                    this.$set(this.selectedAssignee, "patients", patients);
                }
            },
        },
    },

    computed: {
        filteredOrganizationUsers() {
            const email = this.inviteEmail ? this.inviteEmail.trim().toLowerCase() : "";
            if (this.currentTeamUsers) {
                return this.organizationUsers.filter(
                    u =>
                        u.email
                            .trim()
                            .toLowerCase()
                            .includes(email) &&
                        !this.currentTeamUsers.map(c => c.email).includes(u.email) &&
                        this.user.email !== u.email
                );
            }
        },
        organizationUsersWithoutMe() {
            if (this.organizationUsers.length) {
                return this.organizationUsers.filter(
                    u =>
                        u.id !== this.user.id &&
                        u.name.toLowerCase().includes(this.filterString.toLowerCase().trim())
                );
            }
        },
        isOrganizationSuperUser() {
            if (this.user && this.organization) {
                return _.get(this.organization, "pivot.role_id", null) === 1;
            }
        },
    },

    methods: {
        showAddTeamModal() {
            this.$refs.previewAdd.getUpcomingInvoicePreview(1);
            this.modal = this.modals[0];
            this.modal.visible = true;
        },

        showRemoveTeamModal(user) {
            this.$refs.previewRemove.getUpcomingInvoicePreview(-1);
            this.promptDelete(user);
        },

        showResendInviteModal(invite) {
            this.actionInvite = invite;
            this.modal = this.modals[2];
            this.modal.visible = true;
        },

        showCancelInviteModal(invite) {
            this.actionInvite = invite;
            this.modal = this.modals[1];
            this.modal.visible = true;
        },

        resetModal() {
            this.modal = {};
            this.inviteEmail = null;
            this.selectedUser = null;
        },

        addTeamInvite() {
            if (!this.canAddStaff) return;
            this.loading = true;
            this.invalidEmail = false;
            if (
                this.organizationUsers.find(
                    u => u.email.toLowerCase().trim() === this.inviteEmail.toLowerCase().trim()
                ) ||
                this.organizationInvites.find(
                    u => u.email.toLowerCase().trim() === this.inviteEmail.toLowerCase().trim()
                )
            ) {
                this.invalidEmail = true;
                this.loading = false;
                return;
            }
            axios
                .post(`/api/organizations/${this.organization.id}/invites`, {
                    email: this.inviteEmail,
                })
                .then(r => {
                    this.subscription.quantity++;
                    this.inviteEmail = null;
                    this.modal.visible = false;
                    this.loading = false;
                    this.fetchOrganizationInvites();
                })
                .then(() => {
                    mixpanel.track("My Connections - Invite a Team Member", {
                        "New Subscription Quantity": this.subscription.quantity,
                    });
                })
                .catch(e => {
                    this.loading = false;
                    console.error(e);
                });
        },

        resendTeamInvite(id) {
            if (!this.canAddStaff) return;
            this.loading = true;
            axios
                .post(`/api/organizations/${this.organization.id}/invites/${id}/resend`)
                .then(r => {
                    this.modal.visible = false;
                    this.loading = false;
                })
                .catch(e => {
                    console.error(e);
                    this.loading = false;
                });
        },

        removeTeamInvite(id) {
            if (!this.canAddStaff) return;
            this.loading = true;
            axios
                .delete(`/api/organizations/${this.organization.id}/invites/${id}`)
                .then(r => {
                    this.subscription.quantity--;
                    this.modal.visible = false;
                    this.loading = false;
                    this.fetchOrganizationInvites();
                })
                .catch(e => {
                    console.error(e);
                    this.loading = false;
                });
        },

        removeUser(id) {
            if (!this.canAddStaff) return;
            this.loading = true;
            axios
                .delete(`/api/organizations/${this.organization.id}/users/${id}`)
                .then(r => {
                    this.subscription.quantity--;
                    this.loading = false;
                    this.fetchOrganizationUsers();
                    this.resetDelete();
                })
                .catch(e => {
                    console.error(e);
                    this.loading = false;
                    this.resetDelete();
                });
        },

        fetchOrganizationUsers() {
            if (this.organization && this.organization.id) {
                axios
                    .get("/api/organizations/" + this.organization.id + "/users")
                    .then(r => {
                        this.organizationUsers = r.data.data;
                    })
                    .catch(error => {
                        console.error(error);
                    });
            }
        },

        fetchOrganizationInvites() {
            if (!this.isOrganizationSuperUser) return;
            const apiUrl = "/api/organizations/" + this.organization.id + "/invites";
            axios
                .get(apiUrl)
                .then(r => {
                    this.organizationInvites = r.data.data;
                })
                .catch(error => {
                    console.error(error);
                });
        },

        async showAssignResource(assignee) {
            let response = await axios.get(
                `/api/users/${assignee.id}?organization_id=${this.organization.id}`
            );
            if (_.get(response, "data.data", false)) {
                this.$set(this, "selectedAssignee", {
                    ...response.data.data,
                    patients: response.data.patients,
                });
                this.isAssignResourceVisible = true;
            }
        },

        hideAssignResource() {
            this.isAssignResourceVisible = false;
            this.$set(this, "selectedAssignee", null);
        },
    },
};
</script>

<style scoped lang="scss">
.client-image {
    width: 64px;
    height: 64px;
}

.details {
    overflow: hidden;
    > p {
        font-size: 100%;
    }
}

.list-item {
    border: solid 1px #bfbfbf;
}
.list-item:not(:first-child) {
    border-top: none;
}

li {
    font-size: 100%;
    background-color: white;
}

a.dropdown-item {
    font-size: 80%;
    background-color: white;
}

a.dropdown-item:hover {
    background-color: #afd4ee;
    color: white;
}

a.dropdown-item:focus {
    background-color: #afd4ee;
    color: white;
}

.actions:hover {
    background-color: #d64571 !important;
    color: white !important;
}

#filter-string::placeholder {
    font-style: italic;
    color: lightgray;
}
</style>
